export default __webpack_public_path__ + "static/media/2078_00B.19e86a96.jpg";